import { Accordion, Divider, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { DocumentCivilUnionFilterForm } from 'civil-status/view-models/document-civil-union-list';
import SelectLogicOperation from '../../../shell/components/shared/select-choice';
import { list, listEqualOperator, listNameOperator } from 'shell/constants/select-choice-operator';
import { PmiButton } from 'shell/components/shared/button';
import SelectSerie from '../shared/select-serie';
import AutocompleteRegistry from '../shared/autocomplete-registry';
import NumberAct from '../shared/number-act';

interface FiltersDocumentProps {
  filterDocumentForm: FormikProps<DocumentCivilUnionFilterForm>;
}

const FilterDocumentComponent = ({
  filterDocumentForm,
}: FiltersDocumentProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-search-document-filters-content"
        id="panel-search-document-filters-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterDocumentForm.handleSubmit} onReset={filterDocumentForm.handleReset}>
          <Grid container spacing={2} style={{ paddingTop: '0px' }}>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                <PmiTextField
                  label="Anno"
                  aria-label="Anno"
                  id="year"
                  fullWidth
                  inputProps={{
                    maxLength: '4',
                  }}
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('year', event?.target.value);
                  }}
                  value={filterDocumentForm.values.year || ''}
                  helperText={filterDocumentForm.errors.year}
                  error={filterDocumentForm.touched.year && Boolean(filterDocumentForm.errors.year)}
                />
              </Grid>
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={listEqualOperator}
                  id="operation-year"
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('operationYear', event?.target.value);
                  }}
                  value={filterDocumentForm.values.operationYear || ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              {filterDocumentForm.values.operationDocument === '1' ? (
                <>
                  <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                    <NumberAct
                      fullWidth
                      label="Atto"
                      aria-label="Atto"
                      id="from-document"
                      onChange={(event) => {
                        filterDocumentForm.setFieldValue('fromDocument', event?.target.value);
                      }}
                      onBlur={(value) => {
                        filterDocumentForm.setFieldValue('fromDocument', value);
                      }}
                      inputProps={{
                        maxLength: '4',
                      }}
                      value={filterDocumentForm.values.fromDocument || ''}
                      helperText={filterDocumentForm.errors.fromDocument}
                      error={
                        filterDocumentForm.touched.fromDocument &&
                        Boolean(filterDocumentForm.errors.fromDocument)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4} style={{ paddingTop: '10px' }}>
                    <NumberAct
                      label="e il"
                      aria-label="e il"
                      fullWidth
                      id="document-e-il"
                      onChange={(event) => {
                        filterDocumentForm.setFieldValue('toDocument', event?.target.value);
                      }}
                      onBlur={(value) => {
                        filterDocumentForm.setFieldValue('toDocument', value);
                      }}
                      inputProps={{
                        maxLength: '4',
                      }}
                      value={filterDocumentForm.values.toDocument || ''}
                      helperText={filterDocumentForm.errors.toDocument}
                      error={
                        filterDocumentForm.touched.toDocument &&
                        Boolean(filterDocumentForm.errors.toDocument)
                      }
                    />
                  </Grid>
                </>
              ) : (
                <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                  <NumberAct
                    label="Atto"
                    aria-label="Atto"
                    fullWidth
                    onBlur={(value) => {
                      filterDocumentForm.setFieldValue('document', value);
                    }}
                    id="document"
                    onChange={(event) => {
                      filterDocumentForm.setFieldValue('document', event?.target.value);
                    }}
                    inputProps={{
                      maxLength: '4',
                    }}
                    value={filterDocumentForm.values.document || ''}
                    helperText={filterDocumentForm.errors.document}
                    error={
                      filterDocumentForm.touched.document &&
                      Boolean(filterDocumentForm.errors.document)
                    }
                  />
                </Grid>
              )}
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={list}
                  id="operation-document"
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('operationDocument', event?.target.value);
                  }}
                  value={filterDocumentForm.values.operationDocument || ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              {filterDocumentForm.values.operationRegistry === '1' ? (
                <>
                  <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                    <AutocompleteRegistry
                      id="from-registry"
                      label="Registro"
                      onChange={(event) => {
                        filterDocumentForm.setFieldValue('fromRegistry', event);
                      }}
                      value={filterDocumentForm.values.fromRegistry || null}
                      error={
                        filterDocumentForm.touched.fromRegistry &&
                        Boolean(filterDocumentForm.errors.fromRegistry)
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    style={{ paddingTop: '10px' }}
                    display="flex"
                    alignItems="center"
                  >
                    <AutocompleteRegistry
                      label="e il"
                      id="to-registry"
                      onChange={(event) => {
                        filterDocumentForm.setFieldValue('toRegistry', event);
                      }}
                      value={filterDocumentForm.values.toRegistry || null}
                      error={
                        filterDocumentForm.touched.toRegistry &&
                        Boolean(filterDocumentForm.errors.toRegistry)
                      }
                    />
                  </Grid>
                </>
              ) : (
                <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                  <AutocompleteRegistry
                    label="Registro"
                    id="registry"
                    onChange={(event) => {
                      filterDocumentForm.setFieldValue('registry', event);
                    }}
                    value={filterDocumentForm.values.registry || null}
                    error={
                      filterDocumentForm.touched.registry &&
                      Boolean(filterDocumentForm.errors.registry)
                    }
                  />
                </Grid>
              )}
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={list}
                  id="operation-registry"
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('operationRegistry', event?.target.value);
                  }}
                  value={filterDocumentForm.values.operationRegistry || ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                <PmiTextField
                  label="Parte"
                  aria-label="Parte"
                  fullWidth
                  id="portion"
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('portion', event?.target.value);
                  }}
                  inputProps={{
                    maxLength: '2',
                  }}
                  value={filterDocumentForm.values.portion || ''}
                  helperText={filterDocumentForm.errors.portion}
                  error={
                    filterDocumentForm.touched.portion && Boolean(filterDocumentForm.errors.portion)
                  }
                />
              </Grid>
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={listEqualOperator}
                  id="operation-portion"
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('operationPortion', event?.target.value);
                  }}
                  value={filterDocumentForm.values.operationPortion || ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                <SelectSerie
                  isSmallSize
                  label="Serie"
                  id="serie"
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('serie', event?.target.value);
                  }}
                  value={filterDocumentForm.values.serie || ''}
                  error={
                    filterDocumentForm.touched.serie && Boolean(filterDocumentForm.errors.serie)
                  }
                />
              </Grid>
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={listEqualOperator}
                  id="operation-serie"
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('operationSerie', event?.target.value);
                  }}
                  value={filterDocumentForm.values.operationSerie || ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ paddingTop: '10px' }}>
              <Divider />
            </Grid>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
                <PmiTextField
                  label="Matricola"
                  aria-label="Matricola"
                  fullWidth
                  id="matricola"
                  inputProps={{
                    maxLength: '7',
                  }}
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('matricola', event?.target.value);
                  }}
                  value={filterDocumentForm.values.matricola || ''}
                  helperText={filterDocumentForm.errors.matricola}
                  error={
                    filterDocumentForm.touched.matricola &&
                    Boolean(filterDocumentForm.errors.matricola)
                  }
                />
              </Grid>
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={listEqualOperator}
                  id="operation-matricola"
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('operationMatricola', event?.target.value);
                  }}
                  value={filterDocumentForm.values.operationMatricola || ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              <Grid item xs={12} md={10} style={{ paddingTop: '10px' }}>
                <PmiTextField
                  label="Cognome"
                  aria-label="Cognome"
                  fullWidth
                  id="surname"
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('surname', event?.target.value);
                  }}
                  value={filterDocumentForm.values.surname || ''}
                  helperText={filterDocumentForm.errors.surname}
                  error={
                    filterDocumentForm.touched.surname && Boolean(filterDocumentForm.errors.surname)
                  }
                />
              </Grid>
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={listNameOperator}
                  id="operation-surname"
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('operationSurname', event?.target.value);
                  }}
                  value={filterDocumentForm.values.operationSurname || ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
              <Grid item xs={12} md={10} style={{ paddingTop: '10px' }}>
                <PmiTextField
                  label="Nome"
                  aria-label="Nome"
                  fullWidth
                  id="name"
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('name', event?.target.value);
                  }}
                  value={filterDocumentForm.values.name || ''}
                  helperText={filterDocumentForm.errors.name}
                  error={filterDocumentForm.touched.name && Boolean(filterDocumentForm.errors.name)}
                />
              </Grid>
              <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
                <SelectLogicOperation
                  isSmallSize
                  list={listNameOperator}
                  id="operation-name"
                  onChange={(event) => {
                    filterDocumentForm.setFieldValue('operationName', event?.target.value);
                  }}
                  value={filterDocumentForm.values.operationName || ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ paddingTop: '10px' }}>
              <Divider />
            </Grid>
          </Grid>
          {/* Secondo dichiarante */}
          <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
            <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
              <PmiTextField
                label="Matricola"
                aria-label="Matricola"
                fullWidth
                id="matricola2"
                inputProps={{
                  maxLength: '7',
                }}
                onChange={(event) => {
                  filterDocumentForm.setFieldValue('matricola2', event?.target.value);
                }}
                value={filterDocumentForm.values.matricola2 || ''}
                helperText={filterDocumentForm.errors.matricola2}
                error={
                  filterDocumentForm.touched.matricola2 &&
                  Boolean(filterDocumentForm.errors.matricola2)
                }
              />
            </Grid>
            <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
              <SelectLogicOperation
                isSmallSize
                list={listEqualOperator}
                id="operation-matricola2"
                onChange={(event) => {
                  filterDocumentForm.setFieldValue('operationMatricola2', event?.target.value);
                }}
                value={filterDocumentForm.values.operationMatricola2 || ''}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
            <Grid item xs={12} md={10} style={{ paddingTop: '10px' }}>
              <PmiTextField
                label="Cognome"
                aria-label="Cognome"
                fullWidth
                id="surname2"
                onChange={(event) => {
                  filterDocumentForm.setFieldValue('surname2', event?.target.value);
                }}
                value={filterDocumentForm.values.surname2 || ''}
                helperText={filterDocumentForm.errors.surname2}
                error={
                  filterDocumentForm.touched.surname2 && Boolean(filterDocumentForm.errors.surname2)
                }
              />
            </Grid>
            <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
              <SelectLogicOperation
                isSmallSize
                list={listNameOperator}
                id="operation-surname2"
                onChange={(event) => {
                  filterDocumentForm.setFieldValue('operationSurname2', event?.target.value);
                }}
                value={filterDocumentForm.values.operationSurname2 || ''}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} container spacing={2} style={{ paddingTop: '0px' }}>
            <Grid item xs={12} md={10} style={{ paddingTop: '10px' }}>
              <PmiTextField
                label="Nome"
                aria-label="Nome"
                fullWidth
                id="name2"
                onChange={(event) => {
                  filterDocumentForm.setFieldValue('name2', event?.target.value);
                }}
                value={filterDocumentForm.values.name2 || ''}
                helperText={filterDocumentForm.errors.name2}
                error={filterDocumentForm.touched.name2 && Boolean(filterDocumentForm.errors.name2)}
              />
            </Grid>
            <Grid item xs={12} md={2} style={{ paddingTop: '10px' }}>
              <SelectLogicOperation
                isSmallSize
                list={listNameOperator}
                id="operation-name2"
                onChange={(event) => {
                  filterDocumentForm.setFieldValue('operationName2', event?.target.value);
                }}
                value={filterDocumentForm.values.operationName2 || ''}
              />
            </Grid>
          </Grid>

          <div className="pmi-pt-4 pmi-text-md-end">
            <div className="pmi-pr-md-4 pmi-pb-4 pmi-pb-md-0 pmi-d-md-inline-block pmi-d-block pmi-w-md-15">
              <PmiButton variant="contained" color="secondary" type="submit" fullWidth>
                Cerca
              </PmiButton>
            </div>
            <div className="pmi-pr-md-4 pmi-pb-4 pmi-pb-md-0 pmi-d-md-inline-block pmi-d-block pmi-w-md-15">
              <PmiButton variant="outlined" color="cdmBrandSecondary" type="reset" fullWidth>
                Pulisci
              </PmiButton>
            </div>
          </div>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FilterDocumentComponent.displayName = 'Filters Document component';

const FilterDocument = memo(FilterDocumentComponent);

export default FilterDocument;
